// ESM-Huelle fuer lib/scripts/components/CMP_CPushButton.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CPushButton(id, addclass) {
	this.construct(id, addclass);

	this.name = "CPushButton";
	this.htmlType = "div";
        this.addclass=addclass;
	this.caption = null;
	this.container = null;
	this.properties = {
		page : 0,
		xPos : 0,
		yPos : 0,
		events : {
			onMousedown : true,
			onMouseout : true,
			onMouseup : true
		},
		attributes : {
			//undefined: null
		}
	};

	this.setStyleFromXML();
}

CPushButton.prototype = new CComponent;

CPushButton.prototype.prepare = function () {
	this.caption = this.addChild(CCaption);
	this.caption.properties = this.properties.caption;
	//this.caption.properties.styles.width = this.properties.styles.width;
	//this.caption.properties.styles.height = this.properties.styles.height;
/*
	var ids = this.id.split(":");
	var id = ids[0];

	var height = window.screen.availHeight;
	var width = window.screen.availWidth;
	var compheight = height;
	var compwidth = width;

	for (var i = 1; i < ids.length + 1; i++) {
		var comp = POS.getComponentById(id);

		if (comp.properties.styles && comp.properties.styles.height) {
			compheight = comp.properties.styles.height;

			if (compheight && compheight.indexOf("%") > -1) {
				compheight = compheight.replace("%", "");
				height = height * (compheight / 100);
			} else if (compheight && compheight.indexOf("px") > -1) {
				compheight = compheight.replace("px", "");
				height = compheight;
			} else {}
		}

		if (comp.properties.styles && comp.properties.styles.width) {
			compwidth = comp.properties.styles.width;

			if (compwidth && compwidth.indexOf("%") > -1) {
				compwidth = compwidth.replace("%", "");
				width = width * (compwidth / 100);
			} else if (compwidth && compwidth.indexOf("px") > -1) {
				compwidth = compwidth.replace("px", "");
				width = compwidth;
			} else {}
			id = id + ":" + ids[i];
		}
	}

	this.caption.properties.styles.width = parseInt(width) + "px";
	this.caption.properties.styles.height = parseInt(height) + "px";
*/
	this.prepared = true;
}

CPushButton.prototype.onMousedown = function () {
	if (this.properties.sound)
		POS.sound.beep();

	//    this.gfx.illuminate ();
}

export { CPushButton };
